module.exports = __webpack_public_path__ + "public/files/img/slow_send.b9cb6c7f.png";